import Link from 'next/link';
import { useIntl } from 'react-intl';

import { CalmGradients } from '@calm-web/design-system';

import ProfileMenuItem from '@/components/app/profile/ProfileMenuItem';
import { useAuth } from '@/hooks/auth/useAuth';
import { useUserState } from '@/hooks/store';

import { profileItems } from './data';
import messages from './messages';
import { FooterLink, FooterLinks, LoggedInAs, Wrapper } from './styles';

const ProfileHome = () => {
	const { formatMessage } = useIntl();
	const user = useUserState();
	const { isAuth0Enabled, isAuth0User } = useAuth();

	const getProfileItems = () => {
		if (isAuth0Enabled && isAuth0User) {
			return profileItems.filter(
				item => !['/app/profile/change-password', '/app/profile/update-user'].includes(item.route ?? ''),
			);
		}

		return profileItems.filter(item => ![process.env.NEXT_PUBLIC_ACCOUNTS_URL].includes(item.route ?? ''));
	};

	return (
		<Wrapper>
			{user && (
				<>
					<ul>
						{getProfileItems().map((props, index) => (
							<li key={props.name.defaultMessage}>
								<ProfileMenuItem colors={CalmGradients[index]} {...props} />
							</li>
						))}
					</ul>
					{user?.email && (
						<LoggedInAs>
							{formatMessage(messages.loggedInAs, {
								email: user.email,
							})}
						</LoggedInAs>
					)}
					<FooterLinks>
						<li>
							<FooterLink href="https://www.calm.com/faq/web" target="_blank" rel="noreferrer">
								{formatMessage(messages.faq)}
							</FooterLink>
						</li>
						<li>
							<FooterLink href="https://support.calm.com" target="_blank" rel="noreferrer">
								{formatMessage(messages.support)}
							</FooterLink>
						</li>
						<li>
							<Link passHref href="/terms" legacyBehavior>
								<FooterLink>{formatMessage(messages.terms)}</FooterLink>
							</Link>
						</li>
					</FooterLinks>
				</>
			)}
		</Wrapper>
	);
};

export default ProfileHome;
